import React, { FC, useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { usePageTitle } from "../../../../context/navigationContext";
import { BackArrow, Button, ModalVariables, TopProgress } from "../../../../components";
import { PropsContainer } from "../../../../components/table/styles";
import { DropOptions } from "../../../../components";
import { icons } from "../../../../icons";
import {
  Container,
  HeadWrapper,
  RightHeadContainer,
  InstanceName,
} from './styles'
import Overview from './overview'
import { volumeBackupService } from "../../../../api";
import { useUi } from "../../../../context/ui.context";

const VolumeBackupPage: FC = () => {
  const navigate = useNavigate()
  const [t] = useTranslation()
  const [options, setOptions] = useState(false)
  const { backupId } = useParams()
  const { viewAlert } = useUi()
  const [backup, setBackup] = useState<any>()
  usePageTitle(backup ? `${t("PAGE_TITLE_VOLUME_BACKUP_DETAIL")} - ${backup.name || backup.id}` : t("PAGE_TITLE_VOLUME_BACKUP_DETAIL"))
  const [pageLoading, setPageLoading] = useState<boolean>(true)
  const [viewModal, setViewModal] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [activeAnimation, setActiveAnimation] = useState<boolean>(false)
  const [modalType, setModalType] = useState<any>('')
  const [alertTitle, setAlertTitle] = useState<any>('')
  const [alertSubTitle, setAlertSubTitle] = useState<any>()

  const _updateBackup = () => {
    if (backupId) {
      volumeBackupService.getBackup(backupId)
        .then((res) => {
          setBackup(res.data)
          setPageLoading(false)
        })
        .catch((e) => {
          if (e?.response?.data?.detail) {
            viewAlert({
              severity: 'error',
              message: e.response.data?.detail
            })
          }
          setPageLoading(false)
        })
    }
  }

  useEffect(() => {
    _updateBackup()
    const interval = setInterval(() => {
      _updateBackup()
    }, 5000)
    return () => {
      clearInterval(interval)
    }
  }, [backupId])

  const optionsRef: any = useRef()
  const dropsRef: any = useRef()
  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);

  const handleClickOutside = (event: any) => {
    if (optionsRef && !optionsRef.current.contains(event.target) && !dropsRef.current.contains(event.target)) {
      setOptions(false)
    }
  }

  const items = [
    {
      title: t("DELETE"),
      id: '1',
      onClick: () => {
        openModal('delete')
        setAlertTitle(t("VOLUME_BACKUP"))
        setAlertSubTitle([backup])
      },
      icon: icons.DeleteIcon,
      divider: false
    },
  ]

  const openModal = (modal: any) => {
    setModalType(modal)
    setViewModal(true)
    setActiveAnimation(true)
  }

  const closeModal = async (values: any) => {
    let res: any;
    try {
      setLoading(true);
      switch (modalType) {
        case 'delete':
          res = await volumeBackupService.deleteBackup(backup.id);
          if (res?.data?.detail) {
            viewAlert({
              severity: 'info',
              message: res.data?.detail,
            });
          }
          navigate('/openstack/volume-backups')
          break;
      }
      setViewModal(false)
      setActiveAnimation(false)
    } catch (e: any) {
      if (e?.response?.data.detail) {
        viewAlert({
          severity: 'error',
          message: e.response.data.detail,
        });
      }
    } finally {
      setLoading(false);
    }
  }

  const closeModalCancel = () => {
    setViewModal(false)
    setActiveAnimation(false)
  }

  if (pageLoading) return <TopProgress loading={pageLoading} />

  return (
    <Container>
      <BackArrow fallbackPath="/openstack/volume-backups" />
      <HeadWrapper>
        <InstanceName>
          {backup?.name || backup?.id}
        </InstanceName>
        <RightHeadContainer>
          <div ref={dropsRef}>
            <Button
              variant="stroke"
              size='small'
              icon={icons.More}
              isFill
              title={t("MENU")}
              onClick={() => setOptions(!options)}
            />
          </div>
          <PropsContainer style={{ top: '35px', right: '0px' }} ref={optionsRef} active={options}>
            <DropOptions
              options={items}
            />
          </PropsContainer>
        </RightHeadContainer>
      </HeadWrapper>
      <Overview backup={backup} />
      <ModalVariables
        modalType={modalType}
        viewModal={viewModal}
        activeAnimation={activeAnimation}
        closeModal={closeModal}
        closeModalCancel={closeModalCancel}
        alertTitle={alertTitle}
        alertSubTitle={alertSubTitle}
        loading={loading}
      />
    </Container>
  )
}

export default VolumeBackupPage
